'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('redux-form/immutable');

var _uiComponents = require('@wh/ui-components');

var _constants = require('../constants');

require('./checkboxes.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checkboxes component
 * @returns {Element} React element
 */
var Checkboxes = function (_Component) {
    (0, _inherits3.default)(Checkboxes, _Component);

    function Checkboxes() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Checkboxes);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkboxes.__proto__ || (0, _getPrototypeOf2.default)(Checkboxes)).call.apply(_ref, [this].concat(args))), _this), _this.trackEventFieldInteract = function (e) {
            _this.props.trackingEvent(_constants.TRACKING_EVENT_NAME_FORM_INTERACT, {
                formFieldName: e.target.name
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    /**
     * Fires tracking event when user interacts with a form field
     * @param {Object} e event
     * @returns {void}
     */


    (0, _createClass3.default)(Checkboxes, [{
        key: 'renderInput',
        value: function renderInput(_ref2) {
            var id = _ref2.id,
                type = _ref2.type,
                className = _ref2.className,
                input = _ref2.input;

            return _react2.default.createElement(_uiComponents.Input, (0, _extends3.default)({ id: id, type: type, className: className, isChecked: input.checked }, input));
        }
    }, {
        key: 'renderKeepMeLoggedIn',
        value: function renderKeepMeLoggedIn() {
            return this.props.showKeepMeLoggedIn ? (0, _jsx3.default)('div', {
                className: 'c-login-form__checkboxes-input-group'
            }, void 0, (0, _jsx3.default)(_immutable.Field, {
                id: 'keepMeLoggedIn',
                name: 'keepMeLoggedIn',
                type: 'checkbox',
                component: this.renderInput,
                className: 'c-login-form__checkboxes-input',
                onChange: this.trackEventFieldInteract
            }), (0, _jsx3.default)(_uiComponents.FormLabel, {
                style: 'secondary',
                htmlFor: 'keepMeLoggedIn',
                className: 'c-login-form__checkboxes-label'
            }, void 0, this.props.t('login')('modalLabelKeepMeLoggedIn'))) : null;
        }
    }, {
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: 'c-login-form__checkboxes'
            }, void 0, (0, _jsx3.default)('div', {
                className: 'c-login-form__checkboxes-input-group'
            }, void 0, (0, _jsx3.default)(_immutable.Field, {
                id: 'rememberUsername',
                name: 'rememberUsername',
                type: 'checkbox',
                component: this.renderInput,
                className: 'c-login-form__checkboxes-input',
                onChange: this.trackEventFieldInteract
            }), (0, _jsx3.default)(_uiComponents.FormLabel, {
                style: 'secondary',
                htmlFor: 'rememberUsername',
                className: 'c-login-form__checkboxes-label'
            }, void 0, this.props.t('login')('modalLabelRememberUsername'))), this.renderKeepMeLoggedIn());
        }
    }]);
    return Checkboxes;
}(_react.Component);

exports.default = Checkboxes;
//# sourceMappingURL=checkboxes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/checkboxes/checkboxes.js
// module id = 476
// module chunks = 0